"use strict";

var _regeneratorRuntime = require("/go/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AuthProvider = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _auth0SpaJs = _interopRequireDefault(require("@auth0/auth0-spa-js"));

var _get = _interopRequireDefault(require("lodash/get"));

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

var _ljhAnalytics = _interopRequireDefault(require("@clients-modules/js/ljhAnalytics"));

var _Loading = _interopRequireDefault(require("../components/Loading"));

var _index = require("@clients-sites/ljh-platform/src/constants/index");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n          {\n            getMyServices {\n              officeId\n              sections {\n                title\n                items {\n                  title\n                  iconUrl\n                  linkUrl\n                  linkVariant\n                }\n              }\n            }\n          }\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          {\n            getMyAgentProfile: getMyAgentProfileV3 {\n              officePrimaryId\n              offices {\n                officeId\n                officeName\n                roleMaster\n                scope\n              }\n            }\n          }\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AuthContext = /*#__PURE__*/_react["default"].createContext({});

var officeDefaultProps = {
  officeCountry: "australia",
  officeType: "franchise",
  roleMaster: ""
};

var AuthProvider = /*#__PURE__*/function (_Component) {
  _inherits(AuthProvider, _Component);

  var _super = _createSuper(AuthProvider);

  function AuthProvider(_props) {
    var _this;

    _classCallCheck(this, AuthProvider);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      auth0Client: null,
      currentOffice: {},
      currentRole: "unknown",
      currentScope: [],
      currentServices: {},
      email: "",
      isProfileFetched: false,
      offices: [],
      personsCode: "",
      services: []
    });

    _defineProperty(_assertThisInitialized(_this), "initAuth0", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _assertThisInitialize, props, auth0Client, query, isAuthenticated;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _assertThisInitialize = _assertThisInitialized(_this), props = _assertThisInitialize.props;
              _context.next = 3;
              return (0, _auth0SpaJs["default"])({
                domain: (0, _get["default"])(props, "config.auth0Domain"),
                redirect_uri: (0, _get["default"])(props, "config.redirectUri"),
                client_id: (0, _get["default"])(props, "config.auth0ClientId"),
                leeway: 300,
                // 5 minute clock-skew leeway
                scope: "openid email profile"
              });

            case 3:
              auth0Client = _context.sent;

              _this.setState({
                auth0Client: auth0Client
              });

              query = window.location.search; // Check to see if they have been redirected after login

              if (!(query.includes("code=") && query.includes("state="))) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", _this.handleRedirectCallback());

            case 8:
              _context.next = 10;
              return auth0Client.isAuthenticated();

            case 10:
              isAuthenticated = _context.sent;

              if (!isAuthenticated) {
                _context.next = 15;
                break;
              }

              _this.handleAuth();

              _context.next = 17;
              break;

            case 15:
              _context.next = 17;
              return auth0Client.loginWithRedirect();

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleRedirectCallback", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this.state.auth0Client.handleRedirectCallback();

            case 2:
              _this.handleAuth();

              window.history.replaceState({}, document.title, window.location.pathname);

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleAuth", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var auth0Client, user, claims, idToken, email, _user$app_metadata, officeCode, officeName, personsCode, training_role;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              auth0Client = _this.state.auth0Client;
              _context3.next = 3;
              return auth0Client.getUser();

            case 3:
              user = _context3.sent;
              _context3.next = 6;
              return auth0Client.getIdTokenClaims();

            case 6:
              claims = _context3.sent;
              idToken = claims.__raw;

              _this.setSession({
                idToken: idToken
              });

              email = user.email;
              _user$app_metadata = user.app_metadata, officeCode = _user$app_metadata.officeCode, officeName = _user$app_metadata.officeName, personsCode = _user$app_metadata.personsCode, training_role = _user$app_metadata.training_role;

              _ljhAnalytics["default"].identify(email, {
                agentId: personsCode,
                officeId: officeCode,
                officeName: officeName,
                role: training_role
              });

              _this.setState({
                email: email,
                personsCode: personsCode
              });

              _context3.next = 15;
              return _this.setAgentProfile();

            case 15:
              _this.setAgentServices();

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));

    _defineProperty(_assertThisInitialized(_this), "setAgentProfile", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var offices, primaryOffice, result, getMyAgentProfile, referenceCode, currentOffice, currentRole, currentScope;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this.props.client.query({
                query: (0, _graphqlTag["default"])(_templateObject()),
                fetchPolicy: "network-only"
              });

            case 3:
              result = _context4.sent;
              getMyAgentProfile = result.data.getMyAgentProfile;
              offices = getMyAgentProfile.offices;

              if (offices && offices.length > 0) {
                primaryOffice = _objectSpread(_objectSpread({}, officeDefaultProps), offices.find(function (_ref5) {
                  var officeId = _ref5.officeId;
                  return officeId === getMyAgentProfile.officePrimaryId;
                }) || offices[0]);
                primaryOffice.officeType = primaryOffice.officeType || officeDefaultProps.officeType;
              } else {
                primaryOffice = officeDefaultProps;
              }

              _this.setState({
                loginSuccess: true
              });

              _context4.next = 16;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0); // to display reference code in UI

              referenceCode = _context4.t0.message.substring(_context4.t0.message.indexOf("Ref:"), _context4.t0.message.lastIndexOf("]"));

              _this.setState({
                referenceCode: referenceCode,
                loginSuccess: false
              });

              offices = [];
              primaryOffice = officeDefaultProps;

            case 16:
              currentOffice = sessionStorage.getItem("selectedOfc") ? JSON.parse(sessionStorage.getItem("selectedOfc")) : primaryOffice;
              currentRole = _this.getAgentRole(currentOffice.roleMaster);
              currentScope = currentOffice.scope;
              return _context4.abrupt("return", _this.setState({
                offices: offices,
                currentOffice: currentOffice,
                currentRole: currentRole,
                isProfileFetched: true,
                currentScope: currentScope
              }));

            case 20:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "getAgentRole", function (roleMaster) {
      return roleMaster && roleMaster.toLowerCase().replace(" ", "-");
    });

    _defineProperty(_assertThisInitialized(_this), "setAgentServices", function () {
      _this.props.client.watchQuery({
        query: (0, _graphqlTag["default"])(_templateObject2()),
        fetchPolicy: "cache-and-network"
      }).subscribe(function (result) {
        var services = (0, _get["default"])(result, "data.getMyServices") || [];

        var currentServices = _objectSpread({}, services.find(function (_ref6) {
          var officeId = _ref6.officeId;
          return officeId === _this.state.currentOffice.officeId;
        }) || services[0]);

        _this.setState({
          services: services,
          currentServices: currentServices
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCurrentOffice", function (office) {
      var services = _this.state.services;

      var currentOffice = _objectSpread(_objectSpread({}, office), {}, {
        officeType: office.officeType || officeDefaultProps.officeType
      });

      sessionStorage.setItem("selectedOfc", JSON.stringify(currentOffice));

      var currentRole = _index.LJH_ROLES[currentOffice.roleMaster.toLowerCase()];

      var currentServices = _objectSpread({}, services.find(function (_ref7) {
        var officeId = _ref7.officeId;
        return officeId === currentOffice.officeId;
      }) || services[0]);

      var currentScope = currentOffice.scope;

      _this.setState({
        currentOffice: currentOffice,
        currentRole: currentRole,
        currentServices: currentServices,
        currentScope: currentScope
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setSession", function (authResult) {
      if (localStorage) {
        localStorage.setItem("id_token", authResult.idToken);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearSession", function () {
      if (localStorage) {
        localStorage.removeItem("id_token");
        localStorage.removeItem("expires_at");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "logout", function () {
      var auth0Client = _this.state.auth0Client;

      _this.clearSession();

      localStorage.setItem("loggingout", true);
      auth0Client.logout({
        returnTo: (0, _get["default"])(_this.props, "config.baseUrl")
      });
    });

    _this.initAuth0();

    return _this;
  }

  _createClass(AuthProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          auth0Client = _this$state.auth0Client,
          currentOffice = _this$state.currentOffice,
          currentRole = _this$state.currentRole,
          currentServices = _this$state.currentServices,
          email = _this$state.email,
          offices = _this$state.offices,
          personsCode = _this$state.personsCode,
          isProfileFetched = _this$state.isProfileFetched,
          currentScope = _this$state.currentScope,
          referenceCode = _this$state.referenceCode,
          loginSuccess = _this$state.loginSuccess;

      if (!isProfileFetched) {
        if (localStorage.getItem("id_token")) {
          return /*#__PURE__*/_react["default"].createElement(_Loading["default"], null);
        } else if (localStorage.getItem("loggingout")) {
          return /*#__PURE__*/_react["default"].createElement(_Loading["default"], {
            text: "Logging you out..."
          });
        } else {
          return /*#__PURE__*/_react["default"].createElement(_Loading["default"], {
            text: "Loading..."
          });
        }
      } else {
        return /*#__PURE__*/_react["default"].createElement(AuthContext.Provider, {
          value: {
            currentOffice: currentOffice,
            currentRole: currentRole,
            currentScope: currentScope,
            referenceCode: referenceCode,
            loginSuccess: loginSuccess,
            currentServices: currentServices,
            email: email,
            logout: this.logout,
            offices: offices,
            personsCode: personsCode,
            setCurrentOffice: this.setCurrentOffice
          }
        }, children);
      }
    }
  }]);

  return AuthProvider;
}(_react.Component);

exports.AuthProvider = AuthProvider;
AuthProvider.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  config: _propTypes["default"].shape({
    domain: _propTypes["default"].string.isRequired,
    clientID: _propTypes["default"].string.isRequired,
    redirectUri: _propTypes["default"].string.isRequired,
    channel: _propTypes["default"].string.isRequired
  }).isRequired
};
var _default = AuthContext;
exports["default"] = _default;